export enum LoginMessage {
  LOGIN_SUCCESS_MESSAGE = 'Login success fully'
}
